import PropTypes from 'prop-types';

const LoadingBase = ({ children }) => (
  <div aria-hidden="true" className="leading-loose">
    {children}
  </div>
);

LoadingBase.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoadingBase;
